export default __webpack_public_path__ + "static/media/Hatchback_dog5.09230548.png";